<template>
  <div>
    <div class="mi-search page-main">
      <div class="container">
        <div class="search-container">
          <div class="loading" style="display: none">
            <div class="loader"></div>
          </div>
          <div class="container-main" style="">
            <div class="breadcrumbs">
              <div class="container">
                <a href="/">首页</a>
                <span class="sep">&gt;</span>
                <span>{{ $route.params.name }}</span>
              </div>
            </div>
            <div class="search-filter">
              <div class="filter-wrap">
                <div class="filter-list" ref="filter-list">
                  <ul class="item show-less" :class="{ open: item.is_more_open }" v-for="(item, index) in filter_list"
                    :key="index">
                    <span class="label">{{ item.name }}：</span>
                    <li :class="{ active: !form.filter[item.type] !== false }" @click="onClickFilter(item, '')">
                      <a class="product-type-item">全部</a>
                    </li>
                    <li v-for="(sub, index) in item.options" :key="index" @click="onClickFilter(item, sub)" class="filter"
                      :class="{ active: form.filter[item.type] == sub }">
                      <a class="product-type-item">{{ sub }}</a>
                    </li>
                    <span class="more-btn" @click="onMore(item)">更多
                      <i class="iconfont" :class="[
                        item.is_more_open
                          ? 'x-jiantou-shang'
                          : 'x-jiantou-xia',
                      ]" style="font-size: 12px"></i></span>
                  </ul>
                  <div class="fix-position-box"></div>
                </div>
              </div>
            </div>
            <div class="search-result">
              <div class="reuslt-order">
                <div class="order-list-box clearfix">
                  <ul class="order-list" style="display: none">
                    <li class="order-item active">
                      <a goods-order-item="" href="javascript: void(0);">
                        综合
                      </a>
                    </li>
                    <li class="order-item">
                      <a goods-order-item="" href="javascript: void(0);">
                        价格
                      </a>
                    </li>
                  </ul>
                  <ul class="type-list">
                    <li class="hide">
                      <el-checkbox v-model="form.in_stock">仅看有货</el-checkbox>
                    </li>
                    <li>
                      <el-radio-group v-model="form.list_type" size="small">
                        <el-radio-button label="image">
                          <i class="iconfont x-datu"></i> 大图
                        </el-radio-button>
                        <el-radio-button label="list">
                          <i class="iconfont x-liebiao"></i>
                          列表
                        </el-radio-button>
                      </el-radio-group>
                    </li>
                  </ul>
                </div>
                <div class="goods-list-box">
                  <div class="goods-list clearfix" v-show="form.list_type === 'image'">
                    <div class="goods-item" v-for="(goods, index) in goods_list.data" :key="index">
                      <a :href="'/detail/' + goods.id" target="_blank">
                        <div class="figure figure-img">
                          <img :src="goods.image" width="200" height="200" />
                        </div>
                      </a>
                      <h2 class="title">
                        {{ goods.name }}
                      </h2>
                      <p class="price">
                        <span v-show="goods.min_price > 0">{{ goods.min_price }}元起</span>
                        <span v-show="goods.min_price === ''">登录后查看价格</span>
                      </p>
                      <el-button v-show="goods.min_price > 0" class="btn-primary" @click="onBuy(goods)">购买</el-button>
                      <el-button v-show="goods.min_price === ''" class="btn-primary" size="small"
                        @click="onLogin">请登录</el-button>
                    </div>
                  </div>
                </div>
                <el-table v-show="form.list_type === 'list'" :data="goods_list.data" style="width: 100%">
                  <el-table-column prop="oit_code" label="产品编号" width="140">
                    <template #default="scope">
                      <a :href="'/detail/' + scope.row.id" target="_blank">{{ scope.row.oit_code }}</a>
                    </template>
                  </el-table-column>
                  <el-table-column prop="img" label="图片" width="110">
                    <template #default="scope">
                      <el-image :src="scope.row.image" @click="onClickItem(scope.row)"> </el-image>
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" label="商品名称" min-width="160">
                    <template #default="scope">
                      <a :href="'/detail/' + scope.row.id" target="_blank">{{ scope.row.name }}</a>
                    </template>
                  </el-table-column>
                  <el-table-column prop="res.res_model" label="型号" width="120">
                  </el-table-column>
                  <el-table-column prop="res.ext_1" label="品牌" width="90">
                  </el-table-column>
                  <el-table-column prop="price" label="价格" width="95" align="right">
                    <template #default="scope">
                      <span v-show="scope.row.min_price > 0">{{ scope.row.min_price }}元起</span>
                      <span v-show="scope.row.min_price === ''">
                        登录后查看</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="udf_7" label="货期" width="90">
                  </el-table-column>
                  <el-table-column prop="oprate" label="操作" width="120">
                    <template #default="scope">
                      <el-button v-show="scope.row.min_price > 0" class="btn-primary" size="small"
                        @click="onBuy(scope.row)">购买</el-button>
                      <el-button v-show="scope.row.min_price === ''" class="btn-primary" size="small"
                        @click="onLogin">请登录</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div style="text-align: right; margin-top: 15px">
                  <el-pagination layout="prev, pager, next" :total="goods_list.count" :page-size=20
                    @current-change="changeCurrentPage">
                  </el-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog v-if="is_show_popup" v-model="is_show_popup" title="产品信息" :width="1100" @close="closePopup">
      <div class="product-box">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="product-imglist">
              <el-carousel :interval="6000" indicator-position="outside" height="566px">
                <el-carousel-item v-for="item in goods.media_library" :key="item">
                  <el-image style="width: 606px; height: 566px" :src="item.url" fit="cover"></el-image>
                </el-carousel-item>
              </el-carousel>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content bg-purple-dark">
              <div class="product-con">
                <h2>{{ goods.name }}</h2>
                <p class="sale-desc">
                  {{ goods.description }}
                </p>
                <div class="line"></div>
                <div class="buy-option">
                  <div class="buy-box-child">
                    <div class="option-box">
                      <div class="title">包装规格说明</div>
                      <ul class="clearfix">
                        <li v-for="(item, index) in goods.unit" :key="index">
                          <span>
                            {{ item.name }}
                            <span v-show="item.is_main == '0'">
                              ({{ item.rate }}{{ main_unit }})
                            </span>
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div>
                    <a class="btn btn-primary" @click="goLogin" v-show="goods.min_price === ''">登录后查看价格</a>
                  </div>
                  <div class="buy-box-child" v-show="goods.min_price > 0">
                    <div class="option-box">
                      <div class="title">选择数量</div>
                      <el-input-number v-model="form.qty" @change="onCountChange" :min="1" :max="100000" label="描述文字"
                        size="small" style="margin-top: 7px; margin-bottom: 7px"></el-input-number>
                      <div class="price-info">
                        <span class="qty">{{ form.qty }} </span>
                        <span class="unit">{{ main_unit }} </span>
                        <span class="l">|</span>
                        <span class="price">{{ getPrice() }}</span>
                        <span class="yuan">元</span>
                      </div>
                    </div>
                  </div>
                  <div></div>
                  <div class="price-wrap" v-show="goods.min_price > 0">
                    <div class="price-box">
                      <div class="price">价格</div>
                      <div class="desc">起批量</div>
                    </div>
                    <div v-for="(item, index) in goods.plan" :key="index" class="price-box"
                      :class="{ active: active_plan === index }">
                      <div class="price">
                        <span class="rmb">¥</span>
                        <span class="num">{{ item.price }}</span>
                      </div>
                      <div class="desc">{{ item.unit_desc }}</div>
                    </div>
                  </div>
                </div>
                <div class="btn-box" v-show="goods.min_price > 0">
                  <div class="sale-btn">
                    <a class="btn btn-primary" @click="addCart">加入购物车</a>
                  </div>
                  <div class="sale-btn">
                    <a class="btn btn-primary" @click="addInquiry">加入报价篮</a>
                  </div>
                  <a class="btn btn-gray" @click="addLike()">
                    <i v-show="goods.is_like === 1" class="iconfont x-xihuan" style="color: red"></i>
                    <i v-show="goods.is_like === 0" class="iconfont x-xihuan1"></i>
                    喜欢</a>
                </div>
                <div class="selected-list">
                  <ul class="goods-desc">
                    <li>
                      <label>产品编号：</label>
                      <span>{{ goods.oit_code }}</span>
                    </li>
                    <li v-for="(item, index) in goods.udf_text.attr" :key="index">
                      <label>{{ item }}：</label>
                      <span>{{ goods.udf_text.data[index] }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { api } from "@/assets/js/util.js";
export default {
  inject: ["global"],
  watch: {
    $route(to, from) {
      console.log(to, from);
      if (to.fullPath != from.fullPath) {
        this.getData();
      }
    },
  },
  data() {
    return {
      metaInfo:{},
      is_show_popup: false,
      limit: 20,
      page: 1,
      type: "",
      form: {
        is_stock: false,
        list_type: "list",
        filter: {},
        qty: 1,
      },
      goods: {
        udf_text: [{ attr: "" }],
        media_library: [],
      },
      filter_list: [],
      goods_list: {},
      price: 0,
      main_unit: "",
      plan: [],
      active_plan: 0,
      more_open_list: [],
    };
  },
  mounted() {
    this.type = this.$route.type;
    this.getData();
  },
  props: {
    msg: String,
  },
  updated() {
    let that = this;
    that.initMoreBtn();
  },
  methods: {
    onLogin() {
      let url = this.$route.href;
      this.$router.push({ path: "/login", query: { return_url: url } });
    },
    addLike() {
      let that = this;
      let param = {
        goods_id: this.goods.id,
        price: this.price,
        qty: this.form.qty,
      };
      api.post("like/add", param).then(function (res) {
        if (res.code) {
          that.goods.is_like = res.data.is_like;
        } else {
          that.$message({
            type: "error",
            message: res.msg,
            duration: 3000,
          });
        }
      });
    },
    addCart() {
      let that = this;
      let param = {
        goods_id: this.goods.id,
        price: this.price,
        qty: this.form.qty,
      };
      api.post("cart/add", param).then(function (res) {
        if (res.code) {
          that.global.cart_count = res.data;
          that.$message({
            type: "success",
            message: res.msg,
            duration: 1200,
          });
        } else {
          that.$message({
            type: "error",
            message: res.msg,
            duration: 3000,
          });
        }
      });
    },
    addInquiry() {
      let that = this;
      let param = {
        goods_id: this.goods.id,
        price: this.price,
        qty: this.form.qty,
      };
      api.post("inquiry/add_cart", param).then(function (res) {
        that.global.inquiry_count = res.data;
        if (res.code) {
          that.$message({
            type: "success",
            message: res.msg,
            duration: 1200,
          });
        } else {
          that.$message({
            type: "error",
            message: res.msg,
            duration: 3000,
          });
        }
      });
    },
    onCountChange(count) {
      let that = this;
      that.plan.map(function (item, index) {
        if (item.start <= count && item.end >= count) {
          that.active_plan = index;
          that.price = item.price;
        }
      });
    },
    onBuy(item) {
      let that = this;
      that.goods = item;

      that.goods = item;
      that.plan = item.plan;
      that.price = that.plan[0].price;

      let obj = that.goods.unit.find(function (item) {
        return item.is_main == 1;
      });
      if (obj !== undefined) {
        that.main_unit = obj.name;
      }
      that.is_show_popup = true;
    },
    closePopup() {
      let that = this;
      that.is_show_popup = false;
    },
    getQtyText() {
      let that = this;
    },
    getPrice() {
      return Math.round(this.price * this.form.qty * 100) / 100;
    },
    onClickItem(item) {
      window.open("/detail/" + item.id, "_blank");
    },
    onMore(item) {
      let idx = this.more_open_list.indexOf(item.type);
      if (idx === -1) {
        this.more_open_list.push(item.type);
        item.is_more_open = true;
      } else {
        this.more_open_list.splice(idx, 1);
        item.is_more_open = false;
      }

      console.log(this.more_open_list);
    },
    getMoreClass(item) {
      let idx = this.more_open_list.indexOf(item.type);
      if (idx === -1) {
        return "close";
      } else {
        return "open";
      }
    },
    initMoreBtn() {
      let filter_list = this.$refs["filter-list"].getElementsByTagName("ul");
      Array.from(filter_list).forEach((element) => {
        let li_list = element.getElementsByTagName("li");
        Array.from(li_list).forEach((el) => {
          if (el.offsetTop > 0) {
            element.getElementsByClassName("more-btn")[0].style.display =
              "block";
            return false;
          } else {
            element.getElementsByClassName("more-btn")[0].style.display =
              "none";
            return false;
          }
        });
      });
    },
    changeCurrentPage(current) {
      this.page = current;
      this.getData();
    },
    getData() {
      let that = this;
      that.global.isOnCate = false;
      that.global.isShowCate = false;
      let params = this.$route.params;
      params.filter_list = that.filter_list;
      params.limit = 20;
      params.page = this.page;
      params.form = this.form;
      api.post("goods_list", params).then(function (res) {
        if (res.code) {
          that.filter_list = res.data.filter_list;
          that.goods_list = res.data.goods_list;
          that.metaInfo = res.data.metaInfo; 
          that.setPageMeta();

          that.filter_list.map(function (item) {
            let idx = that.more_open_list.indexOf(item.type);
            if (idx === -1) {
              item.is_more_open = false;
            } else {
              item.is_more_open = true;
            }
          });
          that.initMoreBtn();
        }
      });
    },
    onClickFilter(item, sub) {
      console.log(item);
      this.form.filter[item.type] = sub;
      this.getData();
    },
  },
};
</script>
<style scoped>
.product-con h2 {
  margin-top: 7px;
  margin-bottom: 7px;
}

.more-btn {
  display: none;
}

.goods-item {
  cursor: pointer;
}

.option-box ul {
  margin: 0px;
  padding: 0px;
  margin-top: 7px;
  margin-bottom: 7px;
}

.option-box li {
  width: 25%;
  display: inline-block;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-right: 10px;
  text-align: center;
}

.price-wrap {
  margin-top: 15px;
  margin-bottom: 17px;
  border-radius: 2px;
}

.price-box {
  display: inline-block;
  text-align: center;
  width: 16%;
}

.price-box .price,
.price-box .desc {
  height: 28px;
  line-height: 28px;
}

.price-box.active {
  background: rgb(253, 208, 208);
  border-radius: 4px;
}

.price-info {
  margin-left: 20px;
  display: inline-block;
  line-height: 30px;
  height: 30px;
  background: #f3f3f3;
  padding-left: 10px;
  padding-right: 10px;
}

.price-info .qty,
.price-info .l,
.price-info .unit,
.price-info .price,
.price-info .yuan {
  padding-left: 7px;
  padding-right: 7px;
}

.price-info .qty,
.price-info .unit,
.price-info .price,
.price-info .yuan {
  color: red;
}

.price-info .qty,
.price-info .price {
  font-weight: bold;
  font-size: 16px;
  color: red;
}

.btn-box>div {
  display: inline-block;
  margin-right: 20px;
}

.goods-desc {
  background: #f3f3f3;
  padding-top: 10px;
  padding-bottom: 10px;
}

.goods-desc li {
  list-style: none;
  line-height: 24px;
}

.el-dialog__body {
  padding-top: 10px !important;
}

.site-category-list .title {
  display: inline !important;
}

.product-box {
  display: block !important;
}

.filter-list .label {
  padding-left: 10px;
}
</style>
